import { render, staticRenderFns } from "./allMenu.vue?vue&type=template&id=9718bed6&"
import script from "./allMenu.vue?vue&type=script&lang=js&"
export * from "./allMenu.vue?vue&type=script&lang=js&"
import style0 from "./allMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports